import React from 'react';
import { ListBulletIcon, Squares2X2Icon } from '@heroicons/react/24/outline';

interface ViewToggleProps {
  currentView: 'list' | 'grid';
  onViewChange: (view: 'list' | 'grid') => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ currentView, onViewChange }) => {
  return (
    <div className="inline-flex rounded-lg border border-gray-300 bg-white p-1">
      <button
        onClick={() => onViewChange('list')}
        className={`
          flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors
          ${
            currentView === 'list'
              ? 'bg-primary-600 text-white'
              : 'text-gray-700 hover:bg-gray-100'
          }
        `}
        aria-label="List view"
        aria-pressed={currentView === 'list'}
      >
        <ListBulletIcon className="h-5 w-5" />
        <span className="hidden sm:inline">List</span>
      </button>
      
      <button
        onClick={() => onViewChange('grid')}
        className={`
          flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors
          ${
            currentView === 'grid'
              ? 'bg-primary-600 text-white'
              : 'text-gray-700 hover:bg-gray-100'
          }
        `}
        aria-label="Grid view"
        aria-pressed={currentView === 'grid'}
      >
        <Squares2X2Icon className="h-5 w-5" />
        <span className="hidden sm:inline">Grid</span>
      </button>
    </div>
  );
};

export default ViewToggle;

